import * as types from "./mutation-type";
import api from "@/modules/api";

const actions = {
  async getRules({ commit }, variables = {}) {
    try {
      commit(types.GET_RULES_BEGIN);
      const { data } = await api.rule.getRulesList(variables);

      commit(types.GET_RULES_SUCCESS, data);
    } catch (e) {
      commit(types.GET_RULES_ERROR, e);
    }
  },
  async createRule({ commit }, variables ) { 
    try {
      commit(types.CREATE_RULES_BEGIN)
      await api.rule.addRule(variables)
      commit(types.CREATE_RULES_SUCCESS)
    } catch (e) {
      commit(types.CREATE_RULES_ERROR, e)
    }
  },
  async updateRule({ commit }, { id, data }){
    commit(types.UPDATE_RULES_BEGIN)
    try {
      const { data:updatedData } = await api.rule.update(id, data)      
      commit(types.UPDATE_RULES_SUCCESS, updatedData)
    } catch (error) {
      commit(types.UPDATE_RULES_ERROR, error)
    }
  },
  async deleteRule({ commit }, variables ) { 
    try {
      commit(types.DELETE_RULES_BEGIN)
      await api.rule.deleteRule(variables)
      commit(types.DELETE_RULES_SUCCESS)
    } catch (e) {
      commit(types.DELETE_RULES_ERROR, e)
    }
  },
};

export default actions;
